import React from 'react';
import { createPortal } from 'react-dom';

import './Dialog.scss';

export interface DialogCallbacks {
  /**
   * The action for cancelling the dialog.
   * If not specified, the dialog is modal, i.e. it cannot be canceled.
   */
  onDialogCancel?: () => void;
}

export class Dialog extends React.Component<DialogCallbacks> {
  render() {
    const root = document.getElementById('portal-root');
    return createPortal(
      <>
        <div className="dialog-content">{this.props.children}</div>
        <div
          className="dialog-overlay"
          onClick={() => {
            if (this.props.onDialogCancel) {
              this.props.onDialogCancel();
            }
          }}
        ></div>
      </>,
      root,
    );
  }
}
